import React, { useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactDollarField, {
  dollarToInt,
} from 'shared/design-system/components/TrueImpactDollarField';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import { Cost } from './utils';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { capitalizeFirstLetter } from 'shared/utils/stringUtils';
import { numberWithCommas } from 'shared/utils/numberUtils';

interface ProgramCostRow {
  cost: Cost;
  index: number;
  disabled?: boolean;
  className?: string;
  type: 'flex' | 'grid';
  handleDelete?: (index: number) => unknown;
  handleChange: (cost: Cost, index: number) => unknown;
}

const StyledDiv = styled.div<{ type: ProgramCostRow['type'] }>`
  ${({ type }) =>
    type === 'flex'
      ? 'display: flex; align-items: center; justify-content: end;'
      : 'display: grid; align-items: center; grid-template-columns: 1fr 1fr;'}
  .row-text {
    text-align: right;
    padding-right: ${SPACERS.tiny};
  }
  .row-field-wrapper {
    display: flex;
    align-items: center;
    padding-left: ${SPACERS.tiny};
    .row-field {
      max-width: 137px;
      margin-right: ${SPACERS.tiny};
    }
  }
  .cost-text-field-wrapper {
    justify-self: end;
    .cost-text-field {
      max-width: 200px;
      padding-left: ${SPACERS.tiny};
    }
  }
`;

const ProgramCostRow: React.FC<ProgramCostRow> = ({
  cost,
  type,
  index,
  disabled,
  className,
  handleDelete,
  handleChange,
}) => {
  const [text, setText] = useState<string>(cost.text);

  const handleBlur = () =>
    handleChange(
      { text: capitalizeFirstLetter(text), value: cost.value },
      index,
    );

  return (
    <StyledDiv type={type} className={className}>
      {cost.text ? (
        <TrueImpactText variant="body-bold" className="row-text">
          {cost.text}
        </TrueImpactText>
      ) : (
        <div className="cost-text-field-wrapper">
          <TrueImpactTextfield
            value={text}
            autoFocus={true}
            onChange={setText}
            placeholder="Category"
            className="cost-text-field"
            onBlur={handleBlur}
          />
        </div>
      )}
      <div className="row-field-wrapper">
        <TrueImpactDollarField
          disabled={disabled || !cost.text}
          value={cost.value}
          placeholder="Cost"
          className="row-field"
          onBlur={() =>
            cost.value &&
            handleChange(
              {
                value: numberWithCommas(dollarToInt(cost.value).toFixed(2)),
                text: cost.text,
              },
              index,
            )
          }
          onChange={value => handleChange({ value, text: cost.text }, index)}
        />
        {handleDelete && (
          <TrueImpactIconButton
            icon={faTrash}
            label="Delete"
            color="blackBase"
            disabled={false}
            onClick={() => handleDelete(index)}
          />
        )}
      </div>
    </StyledDiv>
  );
};

export default ProgramCostRow;
